module.exports = __webpack_public_path__ + "img/CurrentActivation.4b6e3e38.svg";